<template>
  <div class="body con-wd">
    <breadcrumb :data="['项目', '创建项目', '项目中心']"></breadcrumb>

    <div class="container">
      <el-row>
        <el-col :span="12" class="info-title">项目信息</el-col>
        <el-col :span="12" :style="{ textAlign: 'right',position: 'inherit', top: '153px', right: '20px' }">
          <el-button @click="handleEditProject" icon="el-icon-edit">编辑项目</el-button>
        </el-col>
      </el-row>

      <div class="proj-con">
        <el-descriptions :column="3">
          <el-descriptions-item label="客户名称">{{
              projectInfo.customerName
          }}</el-descriptions-item>
          <el-descriptions-item label="项目名称">{{
              projectInfo.projectName
          }}</el-descriptions-item>
          <el-descriptions-item label="所在省市">{{ projectInfo.province }}-{{
              projectInfo.city
          }}</el-descriptions-item>
          <el-descriptions-item label="商机号/报价号">{{
              projectInfo.quote
          }}</el-descriptions-item>
          <el-descriptions-item label="备注">{{ projectInfo.remark }}
          </el-descriptions-item>
        </el-descriptions>
      </div>
      <div @click="go" style="cursor: pointer">
        <el-row>
          <el-col :span="14" style="margin-top: 0px" class="info-title">
            项目档案
          </el-col>
          <el-col :span="10">
            <div class="archives" @click="go">
              <el-button type="danger">进入档案中心<i class="el-icon-arrow-right el-icon--right"></i></el-button>
            </div>
          </el-col>
        </el-row>
      </div>

      <el-row>
        <el-col :span="24" class="info-title">项目文档</el-col>
      </el-row>

      <el-row :style="{ marginTop: '20px' }">
        <el-col :span="12">
          <el-button @click="handleCopyTask" :disabled="copyTaskId == null">复制文档</el-button>
          <el-button :disabled="copyTaskId == null" @click="handleNewProject">创建新项目</el-button>
        </el-col>
        <el-col :span="12" :style="{ textAlign: 'right' }">
          <el-button :loading="uploadLoading" @click="handleUploadDocument" icon="el-icon-upload2">上传文档</el-button>
          <input class="upload-btn" ref="uploadFile" @change="uploadChange" type="file" id="uploadFile"
                 :accept="accept" />
        </el-col>
      </el-row>

      <div class="doc-list">
        <div class="item">
          <div @click="creatDocument" class="img add"></div>
          <div class="info-con">
            <div>创建新文档</div>
            <p>创建一个空白文档</p>
          </div>
        </div>
        <div class="item" v-for="item in list" :key="item.id">
          <div :class="[
            'img',
            {
              selectable: item.status == '已发布'
            },
            { select: copyTaskId == item.id }
          ]" :style="{
  background: `url('${item.coverUrl}') no-repeat center center /100% auto`
}" @click="handleSelectTask(item)">
            <div :class="[
              'type',
              item.status == '已发布'
                ? 's1'
                : item.status == '未发布'
                  ? 's2'
                  : 's3'
            ]"></div>
          </div>
          <div class="info-con">
            <div>{{ item.documentName }} {{ item.fileType === 0 ? ' .pptx' :(item.fileType === 1 ? '.docx': '.doc')}}</div>
            <p>编辑于&nbsp;{{ item.editTime }}</p>
            <div class="bott">
              <div :class="['info', { publish: item.status == '已发布' }]">
                {{ item.status }}
              </div>
              <div class="edit-con">
                <template v-if="item.status == '已发布' || item.status == '线下文档'">
                  <i class="el-icon-delete" @click="getDelete(item.id)"></i>
                  <i @click="handlePreviewTask(item)" class="el-icon-view"></i>
                  <template v-if="downloading">
                    <i class="el-icon-loading"></i>
                  </template>
                  <template v-else>
                    <i @click="handleDownload(item)" class="el-icon-download"></i>
                  </template>
                </template>
                <template v-else>
                  <i @click="goEdit(item)" class="el-icon-edit"></i>
                </template>
              </div>
            </div>
          </div>
          <div>
            <div class="img1"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from '@/components/pc/Breadcrumb'
import { mapMutations } from 'vuex'
import {detailsDelete, projectDelete} from "@/api/projectManage";
export default {
  name: 'Task',
  components: {
    Breadcrumb
  },
  data() {
    return {
      businessId: null,
      projectInfo: {
        customerName: '', //客户
        projectName: '', //项目
        province: '', //省份
        city: '', //城市
        quote: '', //报价号
        coverUrl: '', //封面图片
        createTime: '',
      },
      uploadLoading: false,
      downloading: false,
      list: [],
      copyTaskId: null,
      accept: '.pptx,.docx,.doc'
    }
  },
  mounted() {
    localStorage.removeItem('Checklist')
    this.changeMenuStatus({ value: 1 })
    this.businessId = this.$route.query.id
    this.getBusinessInfo()
    this.getDocumentTaskList()
  },
  methods: {
    ...mapMutations(['changeMenuStatus']),
    // 删除项目
    getDelete(id) {
      this.$confirm('此操作将永久删除该项目文档，是否继续？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        projectDelete(id).then(res => {
          console.log(res)
          this.getBusinessInfo()
          this.getDocumentTaskList()
          this.$message.success('删除成功')
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    handleEditProject() {
      this.$router.push(`/manage/editproject/${this.businessId}`)
    },
    go(){
      this.$router.push(`/manage/projectDetails/${this.businessId}/0`)
    },
    uploadChange(e) {
      console.log(e, 'file')

      if (e.target.files.length > 0) {
        // 判断文件大小
        let file = e.target.files[0]
        console.log(file.size, 'file.size')
        // if (file.size > 500 * 1024 * 1024) {
        //   this.$message.warning('上传文件不能大于10M.')
        //   return
        // }

        this.uploadLoading = true
        let formData = new FormData()
        formData.append('file', e.target.files[0])
        formData.append('businessOpportunityId', this.businessId)

        this.$request.documentUpload(formData).then((res) => {
          if (res.code == 200) {
            this.$message.success('上传成功')
            this.uploadLoading = false
            this.getDocumentTaskList()
          }
        })
      }
    },
    handleSelectTask(item) {
      if (item.status == '未发布' || item.status == '线下文档') {
        return
      }
      if (item.id === this.copyTaskId) {
        this.copyTaskId = null
      } else {
        this.copyTaskId = item.id
      }
    },
    handlePreviewTask(item) {
      if (item.status == '已发布' || item.status == '线下文档') {
        this.$request.taskPreview(item.id).then((res) => {
          if (res.code == 200) {
            console.log(res, '预览数据')
            // window.open(res.data)
            this.$openWindow(res.data)
          }
        })
      }
    },
    handleUploadDocument() {
      const uploadFileDom = document.querySelector('#uploadFile')
      uploadFileDom.value = ''
      uploadFileDom.click()
    },
    //跳转到模板页
    creatDocument() {
      this.$router.push(`/manage/newdoc/${this.businessId}`)
    },
    goEdit(item) {
      localStorage.removeItem('cachetags')
      //0 默认不显示右侧和数据
      this.$router.push({
        path: `/manage/editdocument/${item.id}/${this.businessId}`,
        query: { hasDefaultSelected: item.hasDefaultSelected}
      })
    },
    getDocumentTaskList() {
      this.$request.getDocumentTaskList(this.businessId).then((res) => {
        if (res.code == 200) {
          this.list = res.data
        }
      })
    },
    getBusinessInfo() {
      this.$request.getBusinessInfo(this.businessId).then((res) => {
        if (res.code == 200) {
          this.projectInfo = res.data
        }
      })
    },
    handleCopyTask() {
      if (this.copyTaskId == null) {
        this.$message.warning('请先选择要复制得文档.')
        return
      }
      this.$request.copyTask(this.copyTaskId).then((res) => {
        if (res.code == 200) {
          this.$message.success('复制成功')
          this.getDocumentTaskList()
        }
      })
    },
    handleNewProject() {
      this.$router.push(`/manage/newproject/${this.businessId}/${this.copyTaskId}`)
    },
    handleDownload(item) {
      this.downloading = true
      this.$request.downloadTaskFile(item.id).then((res) => {
        if (res.code == 200) {
          console.log(res)
          // window.open(res.data)
          this.$openWindow(res.data)
        }
        this.downloading = false
      })
      // this.$request.downloadTaskFile(item.id).then((file) => {
      //   let content = file
      //   // 组装a标签
      //   let elink = document.createElement('a')
      //   // 设置下载文件名
      //   elink.download = new Date().getTime() + '.pptx'

      //   elink.style.display = 'none'
      //   let blob = new Blob([content], {
      //     type: 'application/vnd.openxmlformats-officedocument.presentationml.presentation'
      //   })
      //   elink.href = URL.createObjectURL(blob)
      //   document.body.appendChild(elink)
      //   elink.click()
      //   document.body.removeChild(elink)
      //   this.downloading = false
      // })
    }
  },
  beforeCreate() {
    document.body.setAttribute('style', 'background:#F4F4F5;')
  }
}
</script>

<style lang="less" scoped>
.archives{
  text-align: right;
  line-height: 16px;
  display: flex;
  justify-content: end;
  cursor: pointer;
  &>img{
    width: 16px;
    height: 16px;
  }
}
.container {
  padding: 0 136px;
  padding-bottom: 120px;

  .info-title {
    font-size: 24px;
    color: rgba(0, 0, 0, 0.85);
    font-weight: 500;
    margin-top: 48px;
  }

  .proj-con {
    padding: 29px 24px 19px 24px;
    background-color: #fafafa;
    margin-top: 16px;
    margin-bottom: 50px;
    border-radius: 8px;

    ::v-deep .el-descriptions-item__cell {
      padding: 0 0 10px 0;
    }

    ::v-deep .el-descriptions__body {
      background-color: transparent;
    }

    ::v-deep .el-descriptions-item__content {
      color: #e60027;
    }
  }

  .upload-btn {
    display: none;
  }

  .doc-list {
    margin-top: 4px;
    display: flex;
    flex-wrap: wrap;
    padding-top: 20px;

    &>.item {
      flex: 0 0 240px;
      height: 220px;
      margin-right: 54px;
      margin-bottom: 20px;

      &:nth-child(3n) {
        margin-right: 0;
      }

      &>.img {
        width: 240px;
        height: 136px;
        border-radius: 12px;
        position: relative;
        box-sizing: border-box;
        overflow: hidden;
        border: 1px solid #eee;

        &.add {
          background: url('~@/assets/imgs/add-circle-fill@2x.png') no-repeat center center / 56px auto;
          background-color: #f0f0f0;
        }

        &>.type {
          width: 80px;
          height: 80px;
          transform: translate(-40px, -40px) rotate(-45deg);

          &.s1 {
            font-size: 12px;
            line-height: 20px;
            color: #fff;

            &::after {
              content: '已发布';
              display: block;
              position: absolute;
              left: 0;
              bottom: 0;
              width: 100%;
              height: 20px;
              background-color: #52c41a;
              text-align: center;
              box-sizing: border-box;
            }
          }

          &.s2 {
            font-size: 12px;
            line-height: 20px;
            color: #fff;

            &::after {
              content: '未发布';
              display: block;
              position: absolute;
              left: 0;
              bottom: 0;
              width: 100%;
              height: 20px;
              background-color: #d9d9d9;
              text-align: center;
              box-sizing: border-box;
            }
          }

          &.s3 {
            font-size: 12px;
            line-height: 20px;
            color: #fff;

            &::after {
              content: '线下文档';
              display: block;
              position: absolute;
              left: 0;
              bottom: 0;
              width: 100%;
              height: 20px;
              background-color: #52c41a;
              text-align: center;
              box-sizing: border-box;
            }
          }
        }

        // & > div {
        //   height: 55.18px;
        //   width: 55.18px;
        //   position: relative;
        //   position: absolute;
        //   left: 0;
        //   top: 0;
        //   &.unpub {
        //     background: url('~@/assets/imgs/pic_tag_unfinished@2x.png')
        //       no-repeat center center / 55.18px auto;
        //   }
        //   &.pub {
        //     background: url('~@/assets/imgs/pic_tag_complete@2x.png') no-repeat
        //       center center / 55.18px auto;
        //   }
        // }
        &.selectable {
          cursor: pointer;

          &::after {
            content: '';
            font-size: 12px;
            border-radius: 2px;
            position: absolute;
            right: 6px;
            top: 6px;
            width: 16px;
            height: 16px;
            background: rgba(0, 0, 0, 0.45);
          }
        }

        &.select {
          &::after {
            content: '✔';
            color: #fff;
            font-size: 12px;
            border-radius: 2px;
            position: absolute;
            right: 6px;
            top: 6px;
            width: 16px;
            height: 16px;
            background: #e60027;
            text-align: center;
          }
        }
      }

      &>.imgurl {
        width: 240px;
        height: 136px;
      }

      &>.info-con {
        padding-top: 12px;

        &>div {
          color: rgba(0, 0, 0, 0.85);
        }

        &>p {
          padding-top: 5px;
          font-size: 12px;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.45);
          margin: 0;
        }
      }
    }
  }
}

.bott {
  display: flex;
  margin-top: 6px;
  height: 24px;
  align-items: center;

  &>.info {
    flex: 1;
    color: rgba(0, 0, 0, 0.45);

    &.publish {
      color: #52c41a;
    }
  }

  &>.edit-con {
    flex: 0 0 auto;

    &>i {
      font-size: 16px;
      color: rgba(0, 0, 0, 0.45);
      cursor: pointer;
      margin: 0 5px;

      &:hover {
        color: #e60027;
      }

      &.el-icon-loading {
        cursor: default;
        color: rgba(0, 0, 0, 0.45);
      }
    }

    &>.eye {
      cursor: pointer;
      display: inline-block;
      background: url('~@/assets/imgs/icon_see_default@2x.png') no-repeat center center / 24px auto;
      height: 24px;
      width: 24px;
    }

    &>.download {
      cursor: pointer;
      display: inline-block;
      background: url('~@/assets/imgs/icon_download_default@2x.png') no-repeat center center / 24px auto;
      height: 24px;
      width: 24px;
    }

    &>.edit {
      display: inline-block;
      background: url('~@/assets/imgs/icon_edit_default@2x.png') no-repeat center center / 24px auto;
      height: 24px;
      width: 24px;
      cursor: pointer;
    }
  }
}

.ed {
  margin: 5px auto;
}
</style>
